<div class="ph-page-container bg-white-smoke mt-6 h-auto w-[79vw] flex flex-col ml-[12vw] pb-16 justify-center">
  <div class="location-details-container">

    <!-- Locations Breadcrumbs -->
    <div class="location-breadcrumb-nav-bar">
      <a data-id="location-details" routerLink="/customer-overview" class="link-blue" (click)="trackLocationClick()">
        Locations
      </a>
      <div class="chevron"><img src="assets/chevron-right.svg" alt="chevron-right" /></div>
      <a data-id="customer-location-details" class="last-breadcrumb link-blue">
          {{locationName}} ({{cityState}})
      </a>
    </div>

    <!-- Location Performance Section -->
    <section class="location-perf-container page-section" id="location-details-perf-section">
      <div class="title-row">
        <h3 class="section-title location">Location Performance</h3>
      </div>

        <div class="chart-row" *ngIf="!isLoading; else loadingTemplate">
          <ng-container *ngIf="haslocationPerformanceData; else noDataTemplate">
            <!-- Gauge Chart -->
            <div class="gauge-chart-container">
              <app-gauge-chart
                [needleValue]="gaugeNeedleValue"
                [chartLabel]="'Performance Rating'"
                [chartBottomText]="'Higher the score, better the <br />performance'">
              </app-gauge-chart>
            </div>

            <!-- Performance Line Chart -->
            <div class="performance-rating-line-chart-container">
              <div class="pr-line-chart-title">Performance Rating</div>
              <div class="chart-wrapper">
                <app-line-graph-common-chart [config]="lineChartConfig" [unique_id]="'location-details'">
                </app-line-graph-common-chart>
              </div>
            </div>
          </ng-container>
        </div>
    </section>

    <!-- Location Insights Details Section-->
     <section class="location-insights-container page-section" id="location-details-insights-section">
      <div class="title-row">
        <h3 class="section-title location">Location Insights</h3>
      </div>

      <ph-location-insights-details></ph-location-insights-details>
    </section>

    <ng-template #loadingTemplate>
      <div class="loading-container">
        <loader size="medium"></loader>
        <p>Loading...</p>
      </div>
    </ng-template>

    <ng-template #noDataTemplate>
      <div class="no-data-container">
        <p>No data available</p>
      </div>
    </ng-template>

  </div> <!-- End of location details container-->
</div>
